import { createQueryKeys } from '@lukemorales/query-key-factory'
import AivatarClient from '../AivatarClient'

export type PlanFeature = {
  id: number
  name: string
  value: number | null
  description: string | null
}

export type Plan = {
  id: number
  name: string
  displayName: string
  description: string | null
  /** 부가세 별도 월 요금 */
  price: number
  vat: number
  /** 부가세 포함 월 요금 */
  amount: number
  currency: string
  level: number
  features: PlanFeature[]
  /** BE 가 /v1/plans 에 실으면 채워진다. 없으면 FE 가 계산한다 (services/payments/annual) */
  annualAmount?: number | null
  annualDiscountRate?: number | null
}

export async function getPlanList(): Promise<Plan[]> {
  const response = await AivatarClient().get('/plans')
  return response.data.content
}

/** 플랜이 매월 지급하는 크레딧. 연간도 매월 분할 충전이라 값은 같다 (정책 6.2) */
export function getMonthlyCredit(plan?: Pick<Plan, 'features'> | null) {
  return plan?.features?.find((feature) => feature.name === 'CREDIT')?.value ?? null
}

export const planQueries = createQueryKeys('plan', {
  list: {
    queryKey: null,
    queryFn: () => getPlanList(),
  },
})
